import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { getLinkCustomerHostawayUrl } from "./api-url.constants";
import { LinkCustomerHostawayError } from "./errors";

interface LinkCustomerHostawayBody {
  clientId: string;
  clientSecret: string;
  userId?: string;
}

export const linkCustomerHostaway = async (body: LinkCustomerHostawayBody): Promise<void> => {
  const response = await typedFetch(getLinkCustomerHostawayUrl(body.userId), {
    method: API_METHODS.POST,
    body: JSON.stringify({
      accountId: body.clientId,
      clientSecret: body.clientSecret,
    }),
  });

  if (!response.ok) throw new LinkCustomerHostawayError();
};
